// ==============================|| REDIRECT ||============================== //

/**
 * Whether a value is safe to hand to `window.location`.
 *
 * `http(s)` only, and absolute. The authorize URLs always come from our own API, so this guards
 * against a broken response rather than a hostile one. It costs nothing either way: a relative value
 * would resolve inside the SPA, and `javascript:` must never reach `location`.
 */
export const isAbsoluteHttpUrl = (value: unknown): value is string => {
  if (typeof value !== 'string' || value === '') return false;

  try {
    return ['http:', 'https:'].includes(new URL(value).protocol);
  } catch {
    return false;
  }
};

/** Navigates the whole page to an identity-provider URL, or throws if the value is not one. */
export const redirectToExternal = (url: unknown): void => {
  if (!isAbsoluteHttpUrl(url)) {
    throw new Error('Identity provider returned an invalid authorize URL');
  }

  window.location.assign(url);
};
